import { Tabs } from 'antd';
import styled from 'styled-components';

/**
 * @deprecated use Tabs from '@frontend/components' instead.
 */
export const OldTabs = styled(Tabs)`
  width: 100%;
  > .ant-tabs-nav {
    margin-bottom: 20px;
  }
  > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list {
    .ant-tabs-tab {
      color: #828282;
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      padding: 8px 15px;
      text-align: left;
      transition: all 0.2s ease;

      &:hover {
        color: #333;
      }
    }

    .ant-tabs-tab-active > .ant-tabs-tab-btn {
      color: #333;
    }
  }

  .ant-tabs-ink-bar {
    background-color: #268af5;
    height: 5px !important;
  }
`;
